module.exports = __webpack_public_path__ + "img/ACT.93400bab.svg";